import { GREY_BACKGROUND, OUTLINE_COLOR, CLICKABLE_COLOR, SITE_NAVY_COLOR } from '@CSSVars/colors'
import { motion } from 'framer-motion'
import Flex from 'Components/Flex'
import styled from 'styled-components'

export const _MinimizedMenu = styled(motion.div).attrs({
  'data-test-id': 'minimizedMenu',
})`
  width: 100%;
  left: 0;
  pointer-events: all;
    button {
    width: 100%;
    border: 0;
    padding: 12px 0;
    height: 72px;
    font-size: 12px;
    &:hover {
      cursor: pointer;
    }
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 12px 0;
    height: 72px;
    &:first-child {
      padding: 16px 0;
      height: 56px;
      border-bottom: 1px solid ${OUTLINE_COLOR};
      svg {
        margin: 0;
        fill: ${CLICKABLE_COLOR}
      }
    }
  }
  svg {
    margin-bottom: 6px;
  }

`

export const _AlertButtonContents = styled(Flex)`
  font-size: 12px;

`
export const _CircleIcon = styled(Flex)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${OUTLINE_COLOR};
  color: white;


`
export const _MenuItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: none;
  text-transform: capitalize;
  font-size: 12px;
  background: ${props => (props.greyBackground ? GREY_BACKGROUND : 'transparent')};
  ${props => (
    props.selected
      ? `
          background: ${SITE_NAVY_COLOR};
          color: white;
          path {
            fill: white;
          }
          svg {
            fill: white;
          }`
      : ''
  )}
`
export const _ToNormalizeSizeButton = styled.div`
  width: 100%;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(180deg);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${GREY_BACKGROUND};
  }
`
